import React from 'react';
import bijouxImage from '../../images/bijoux.PNG';
import CategoryPage from '../CategoryPage';

function BijouxPage() {
    const details = [
        'Bagues anciennes',
        'Colliers et pendentifs',
        'Bracelets et manchettes',
        'Broches et épingles',
        'Pendants d’oreilles',
        'Montres de luxe serties',
        'Bijoux en or, platine, et argent',
        'Pierres précieuses : diamants, rubis, émeraudes, et saphirs',
        'Créations signées par de grands joailliers',
    ];

    const description = `
        En tant qu’antiquaire passionné, je suis toujours à la recherche de bijoux anciens et de pièces de joaillerie d’exception, même s’ils sont abîmés et nécessitent une restauration. Je rachète avec soin des bagues, des colliers, des bracelets, des broches, des pendants d’oreilles, ainsi que des montres de luxe serties. Que ce soit des créations signées par de grands joailliers, des bijoux en or, platine ou argent, ou encore des pierres précieuses telles que diamants, rubis, émeraudes et saphirs, je suis à l’affût de pièces uniques ou rares.

        Mon intérêt dépasse la matière : je recherche l’objet en lui-même, porteur d’histoire et de beauté. Chaque bijou, ancien ou récent, a une âme et une valeur au-delà de sa composition. Si vous souhaitez vendre vos pièces, contactez-moi pour une évaluation juste et un prix adapté, afin qu’elles continuent de briller.
    `;

    return (
        <CategoryPage
            title="Bijoux"
            image={bijouxImage}
            description={description}
            details={details}
        />
    );
}

export default BijouxPage;
